/* Author:
@indaamcom
*/

$ = jQuery.noConflict();
// Document ready

jQuery(document).ready(function($) {

	// $('body').parent().removeClass("no-js");
	$('body').parent().addClass("has-js");
	$('#site-navigation').before('<div id="toggle-menu"><a href="#">Open menu</a></div>');


	if(navigator.vendor != null && navigator.vendor.match(/Apple Computer, Inc./) && navigator.userAgent.match(/iPhone/i) || (navigator.userAgent.match(/iPod/i))) {
		$('body').parent().addClass("this-is-ipad");
	}

	var isiPad = navigator.userAgent.match(/iPad/i) != null;

	if(isiPad){
		$('body').parent().addClass("this-is-ipad");
	};

	$('#collections-listing > h2').addClass("title-wrapper");
	$('#collections-listing > ul').addClass("listing-content");
	$('#collections-listing > ul').wrap("<div class='wrapper'>");

	$('.custom-select').selectbox();

	var listItemWidth = $("#products .list-items").width();
	$("#products .list-items + .paging").width( listItemWidth );
	$("#products .list-items").parents("#main").find("#primary").next().next().width( listItemWidth );

	$('.variations tr td').addClass("td");
	$('.variations tr td:nth-child(2n)').addClass("td-two");

	$('.buttons_added .button').addClass("arloji-submit");
	$('#products .list-items .list .note-sold-out').parent().addClass("this-sold-out");


	$("#s_top").focusin(function() {
		$(this).removeAttr("placeholder");
	});
	$("#s_top").focusout(function() {
		$(this).attr("placeholder", "Type here to search");
	});

	$("#email-input").focusin(function() {
		$(this).removeAttr("placeholder");
	});
	$("#email-input").focusout(function() {
		$(this).attr("placeholder", "your@email.com");
	});

	$("#toggle-menu a").click(function() {
		$("#site-navigation #menu-primary").slideToggle(600);
	});

});


// Document load
jQuery(window).load(function(){

	$('.bwWrapper').BlackAndWhite({
		hoverEffect : true, // default true
		// set the path to BnWWorker.js for a superfast implementation
		webworkerPath : false,
		// for the images with a fluid width and height 
		responsive: false,
		// to invert the hover effect
		invertHoverEffect: false,
		speed: { //this property could also be just speed: value for both fadeIn and fadeOut
			fadeIn: 400, // 200ms for fadeIn animations
			fadeOut: 600 // 800ms for fadeOut animations
		}
	});
});